// extracted by mini-css-extract-plugin
export default {"button":"DonateButton_button__D6Lna","yellow":"DonateButton_yellow__IUDKt"};